import { IGiveawayAutoParticipant } from "../../../interfaces";

class GiveawayAutoParticipantMapper {
    toPersistence(domainGiveawayParticipant: IGiveawayAutoParticipant): any {
        return {
            id: domainGiveawayParticipant.id,
            name: domainGiveawayParticipant.name,
            cpf_cnpj: domainGiveawayParticipant.cpf_cnpj,
            total_tickets: domainGiveawayParticipant.total_tickets,
        }
    }

    toDomain(persistenceGiveawayParticipant: any): IGiveawayAutoParticipant {
        return {
            id: persistenceGiveawayParticipant.id,
            name: persistenceGiveawayParticipant.name,
            cpf_cnpj: persistenceGiveawayParticipant.cpf_cnpj,
            total_tickets: persistenceGiveawayParticipant.total_tickets,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new GiveawayAutoParticipantMapper();
